module.exports = __webpack_public_path__ + "img/wen style1.e9677476.png";